export const dict = {
  en: {
    nav: { apps: "Apps", about: "Studio", contact: "Contact", privacy: "Privacy", cta: "Say hello", menu: "Menu", close: "Close" },
    hero: {
      eyebrow: "Independent app studio · Denmark",
      lines: ["Calm apps", "for a busy", "world."],
      sub: "ZenVio designs and builds focused, AI-powered mobile apps for Google Play and the App Store — tools that do one thing beautifully, then get out of your way.",
      ctaPrimary: "Explore the apps",
      ctaSecondary: "Start a conversation",
      stores: "Coming to Google Play & App Store",
      scroll: "Scroll",
      stats: [["04", "Apps in the studio"], ["iOS + Android", "Native-feeling on both"], ["DK", "Designed in Denmark"]],
    },
    apps: {
      eyebrow: "01 — The collection",
      titleLines: ["Four apps.", "One quiet philosophy."],
      sub: "Four AI-powered apps, each built around one real problem — from your Google rankings to your daily motivation.",
      view: "View app",
    },
    status: { pending: "Awaiting Google Play activation", dev: "In development", live: "Available now" },
    badges: { getItOn: "Get it on", downloadOn: "Download on the", soon: "Coming soon", pending: "Awaiting activation" },
    marquee: ["Calm software", "AI SEO", "Daily kindness", "Second brain", "Social growth", "Made in Denmark"],
    about: {
      eyebrow: "02 — The studio",
      titleLines: ["Small apps,", "made with", "serious care."],
      p1: "ZenVio is an independent app studio from Denmark. I design, build and ship mobile apps for Android and iOS — each one focused, fast and respectful of your time.",
      p2: "Every app starts with a simple question: how could this feel calmer? The answer shapes everything, from the first sketch to the last line of code.",
      principles: [
        ["Focus", "Every app solves one real problem — no bloat, no dark patterns."],
        ["Privacy", "Data stays on your device whenever possible. GDPR by default."],
        ["Craft", "Smooth motion, native-feeling performance and care for detail on iOS and Android."],
      ],
    },
    contact: {
      eyebrow: "03 — Contact",
      titleLines: ["Let's", "talk."],
      sub: "Questions, feedback, beta access or partnerships — drop a line and I'll get back to you.",
      name: "Your name", email: "E-mail", app: "What is it about?", general: "General", message: "Your message",
      submit: "Send message", sending: "Sending…",
      success: "Thanks! Your message has been sent.", successSub: "A reply is already on its way to your inbox — and I'll follow up personally if needed.",
      again: "Send another message",
      error: "Something went wrong. Please try again.",
      invalid: "Please fill in all fields correctly.",
      location: "Based in", locationValue: "Denmark",
      web: "Web",
    },
    footer: { tagline: "Calm apps for a busy world.", rights: "All rights reserved", apps: "Apps", legal: "Legal", studio: "Studio", studioPrivacy: "Website privacy", deleteAccount: "Delete account", top: "Back to top" },
    detail: { back: "All apps", features: "What it does", privacy: "Privacy policy", next: "Next app", status: "Status", platforms: "Platforms", category: "Category", launchTitle: "Want to know when it launches?", launchCta: "Get in touch", screensEyebrow: "Screenshots", screens: "Inside the app" },
    privacy: { title: "Privacy Policy", updated: "Last updated", toc: "Contents", for: "Applies to", website: "zenvio.dk website" },
    waitlist: {
      eyebrow: "Launch list",
      title: (n) => `Be the first to know when ${n} launches.`,
      sub: "Leave your e-mail and you'll get a single message the day it lands on Google Play and the App Store. No spam, ever.",
      placeholder: "you@email.com",
      cta: "Notify me", sending: "Joining…",
      pending: "Almost there — check your inbox and confirm your e-mail.",
      already: "You're already on the list. See you at launch!",
      invalid: "Please enter a valid e-mail address.",
      error: "Something went wrong. Please try again.",
      confirmed: "You're on the list! We'll e-mail you at launch.",
      unsubscribed: "You've been removed from the launch list.",
      invalidLink: "That link is no longer valid.",
    },
    notFound: { title: "Lost in the calm.", cta: "Back home" },
  },
  da: {
    nav: { apps: "Apps", about: "Studiet", contact: "Kontakt", privacy: "Privatliv", cta: "Sig hej", menu: "Menu", close: "Luk" },
    hero: {
      eyebrow: "Uafhængigt app-studie · Danmark",
      lines: ["Rolige apps", "til en travl", "verden."],
      sub: "ZenVio designer og udvikler fokuserede mobilapps til Google Play og App Store — værktøjer, der gør din hverdag lettere, uanset om du er privatperson eller selvstændig erhvervsdrivende.",
      ctaPrimary: "Udforsk apps",
      ctaSecondary: "Start en samtale",
      stores: "Snart på Google Play & App Store",
      scroll: "Scroll",
      stats: [["04", "Apps i studiet"], ["iOS + Android", "Føles native på begge"], ["DK", "Designet i Danmark"]],
    },
    apps: {
      eyebrow: "01 — Kollektionen",
      titleLines: ["Fire apps.", "Én rolig filosofi."],
      sub: "Fire AI-drevne apps, hver bygget omkring ét ægte problem — fra dine Google-placeringer til din daglige motivation.",
      view: "Se app",
    },
    status: { pending: "Afventer aktivering på Google Play", dev: "Under udvikling", live: "Tilgængelig nu" },
    badges: { getItOn: "Få den på", downloadOn: "Hent i", soon: "Kommer snart", pending: "Afventer aktivering" },
    marquee: ["Rolig software", "AI SEO", "Daglig venlighed", "Anden hjerne", "Social vækst", "Skabt i Danmark"],
    about: {
      eyebrow: "02 — Studiet",
      titleLines: ["Små apps,", "skabt med", "stor omhu."],
      p1: "ZenVio er et uafhængigt app-studie fra Danmark. Jeg designer, bygger og udgiver mobilapps til Android og iOS — hver især fokuseret, hurtig og respektfuld over for din tid.",
      p2: "Hver app starter med et enkelt spørgsmål: hvordan kan det her føles roligere? Svaret former alt, fra den første skitse til den sidste kodelinje.",
      principles: [
        ["Fokus", "Hver app løser ét ægte problem — ingen overflod, ingen mørke mønstre."],
        ["Privatliv", "Data bliver på din enhed, når det er muligt. GDPR som standard."],
        ["Håndværk", "Flydende animationer, native-følelse og omhu for detaljen på iOS og Android."],
      ],
    },
    contact: {
      eyebrow: "03 — Kontakt",
      titleLines: ["Lad os", "tale."],
      sub: "Spørgsmål, feedback, beta-adgang eller samarbejde — skriv en linje, så vender jeg tilbage.",
      name: "Dit navn", email: "E-mail", app: "Hvad drejer det sig om?", general: "Generelt", message: "Din besked",
      submit: "Send besked", sending: "Sender…",
      success: "Tak! Din besked er sendt.", successSub: "Et svar er allerede på vej til din indbakke — og jeg følger personligt op, hvis det er nødvendigt.",
      again: "Send en ny besked",
      error: "Noget gik galt. Prøv venligst igen.",
      invalid: "Udfyld venligst alle felter korrekt.",
      location: "Baseret i", locationValue: "Danmark",
      web: "Web",
    },
    footer: { tagline: "Rolige apps til en travl verden.", rights: "Alle rettigheder forbeholdes", apps: "Apps", legal: "Juridisk", studio: "Studiet", studioPrivacy: "Hjemmesidens privatliv", deleteAccount: "Slet konto", top: "Til toppen" },
    detail: { back: "Alle apps", features: "Hvad den kan", privacy: "Privatlivspolitik", next: "Næste app", status: "Status", platforms: "Platforme", category: "Kategori", launchTitle: "Vil du have besked ved lancering?", launchCta: "Skriv til mig", screensEyebrow: "Skærmbilleder", screens: "Se appen indefra" },
    privacy: { title: "Privatlivspolitik", updated: "Senest opdateret", toc: "Indhold", for: "Gælder for", website: "zenvio.dk-hjemmesiden" },
    waitlist: {
      eyebrow: "Lanceringsliste",
      title: (n) => `Få besked, så snart ${n} lanceres.`,
      sub: "Skriv din e-mail, så får du én enkelt besked den dag, appen lander på Google Play og App Store. Aldrig spam.",
      placeholder: "dig@email.dk",
      cta: "Giv mig besked", sending: "Tilmelder…",
      pending: "Næsten færdig — tjek din indbakke og bekræft din e-mail.",
      already: "Du er allerede på listen. Vi ses ved lanceringen!",
      invalid: "Indtast venligst en gyldig e-mailadresse.",
      error: "Noget gik galt. Prøv venligst igen.",
      confirmed: "Du er på listen! Vi sender dig en e-mail ved lanceringen.",
      unsubscribed: "Du er fjernet fra lanceringslisten.",
      invalidLink: "Linket er ikke længere gyldigt.",
    },
    notFound: { title: "Faret vild i roen.", cta: "Til forsiden" },
  },
};
